export default "__VITE_ASSET__5f4e8d93__"